"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a date is after or equal to another date, if no specific date is passed todays date will be used.
 * @param message
 * @param fieldID
 * @param afterDateVal
 * @returns {function({field: *})}
 */
var isDateEqualToOrAfter = function isDateEqualToOrAfter(message, fieldID, afterDateVal) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;

    // This is not an 'isRequired' validator
    if (!field.value) {
      return true;
    }

    var enteredDate = (0, _moment.default)(field.value, 'DD/MM/YYYY');
    var afterDate = (0, _moment.default)((0, _moment.default)().format('DD/MM/YYYY'), 'DD/MM/YYYY'); // need to coerce because we don't care about specific hours

    if (afterDateVal) {
      if (afterDateVal && (0, _moment.default)(afterDateVal, 'DD/MM/YYYY').format('DD/MM/YYYY') === afterDateVal) {
        afterDate = (0, _moment.default)(afterDateVal, 'DD/MM/YYYY');
      }
    } // get date entered in another field (if fieldID is provided)


    if (fieldID) {
      var afterDateStr = form.$(fieldID).value;

      if (afterDateStr) {
        afterDate = (0, _moment.default)(afterDateStr, 'DD/MM/YYYY');
      }
    } // check if entered date is valid


    var isValid = enteredDate.isSameOrAfter(afterDate); // return

    return [isValid, message || "Please enter date equal to or after ".concat(afterDate.format('DD/MM/YYYY'), ".")];
  };
};

var _default = isDateEqualToOrAfter;
exports.default = _default;
//# sourceMappingURL=isDateEqualToOrAfter.js.map